// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Z1rq","title":"Info_title__3mPMF","links":"Info_links__2AQ5_","link":"Info_link__2cjQj","logo":"Info_logo__3HWun"};